import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import PDF from '../../../component/pdf';
import Title from '../../../component/title';
import HeadPdf from '../../../component/head-pdf';
import FootPdf from '../../../component/foot-pdf';
import moIndex from '../../../store/index';
import moFreshCity from './store';
import Empty from '@comp/empty/index';
import moUser from '@store/user';
import ChartPDF from './chart-pdf';
import TablePDF from './table-pdf';
import ExplainPDF from './explain-pdf';

interface IProps {}
interface IState {}

const SalaryIndustryPDF = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry } = moIndex;
  const { xData, pageNum } = moFreshCity;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <>
      {!isEmpty(xData) ? (
        <>
          <ChartPDF />
          {xData.length > 0 ? <TablePDF /> : null}
        </>
      ) : null}
    </>
  );
};

export default observer(SalaryIndustryPDF);
